<template>
  <b-row>
    <b-col md="12">
      <component-header
        title="Build Generation"
        :hasSearch="false"
        :hasReload="false"
        :hasCreate="false"
        :hasback="false"
      />
    </b-col>
    <b-col>
      <ValidationObserver ref="observer">
        <b-card>
          <b-row>
            <b-col md="12">
              <b-tabs v-model="tabIndex">
                <b-tab title="Customer App">
                  <b-container fluid>
                    <h4>Select Platform</h4>
                    <b-form-group class="mb-0 pt-2">
                      <b-form-checkbox
                        type="checkbox"
                        size="lg"
                        id="mobile"
                        value="true"
                        v-model="phn"
                      >
                        <h4 class="m-0 font-weight-light">Mobile App</h4>
                      </b-form-checkbox>
                      <b-form-checkbox
                        type="checkbox"
                        size="lg"
                        id="web"
                        value="true"
                        v-model="web"
                      >
                        <h4 class="m-0 font-weight-light">Web App</h4>
                      </b-form-checkbox>
                    </b-form-group>
                    <b-row v-if="phn">
                      <b-col md="6" class="pb-2">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          name="App name"
                        >
                          <b-form-input
                            placeholder="Enter App Name"
                            v-model="appName"
                          ></b-form-input>
                          <span class="validate-error">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </b-col>
                      <b-col md="6" class="pb-2">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          name="App version"
                        >
                          <b-form-input
                            placeholder="Enter App Version"
                            v-model="appVersion"
                          ></b-form-input>
                          <span class="validate-error">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </b-col>
                    </b-row>
                    <b-row v-if="phn || web">
                      <!-- <b-col md="6" class="pb-2">
        <b-card>
          <b-row>
            <b-col md="12">
              <b-tabs v-model="tabIndex">
                <b-tab title="Customers App">
                  <b-container fluid>
                    <h4>Select Platform</h4>
                    <b-form-group class="mb-0 pt-2">
                      <b-form-checkbox
                        type="checkbox"
                        size="lg"
                        id="mobile"
                        value="true"
                        v-model="phn"
                      >
                        <h4 class="m-0 font-weight-light">Mobile App</h4>
                      </b-form-checkbox>
                      <b-form-checkbox
                        type="checkbox"
                        size="lg"
                        id="web"
                        value="true"
                        v-model="web"
                      >
                        <h4 class="m-0 font-weight-light">Web App</h4>
                      </b-form-checkbox>
                    </b-form-group>
                    <b-row v-if="phn">
                      <b-col md="6" class="pb-2">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          name="App name"
                        >
                          <b-form-input
                            placeholder="Enter App Name"
                            v-model="appName"
                          ></b-form-input>
                          <span class="validate-error">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </b-col>
                      <b-col md="6" class="pb-2">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          name="App version"
                        >
                          <b-form-input
                            placeholder="Enter App Version"
                            v-model="appVersion"
                          ></b-form-input>
                          <span class="validate-error">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </b-col>
                    </b-row>
                    <b-row v-if="phn || web">
                      <!-- <b-col md="6" class="pb-2">
                      <b-form-group class="mb-0 pt-2">
                        <b-form-checkbox
                          type="checkbox"
                          size="lg"
                          id="privacy_url"
                          value="true"
                        >
                          <h4 class="m-0 font-weight-bold">
                            Select nipige privacy URL
                          </h4>
                        </b-form-checkbox></b-form-group
                      >
                    </b-col>
                    <b-col md="6" class="pb-2">
                    <b-col md="6" class="pb-2">
                      <b-form-input
                        placeholder="Enter Privacy Policy URL"
                      ></b-form-input>
                    </b-col> -->
                      <b-col md="6" class="pb-2">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          name="Google client API"
                        >
                          <b-form-input
                            placeholder="Google Api Key"
                            v-model="googleClientId"
                          ></b-form-input>
                          <span class="validate-error">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </b-col>
                      <!-- <b-col md="6" class="pb-2"> <b>Stage Tracker</b></b-col> -->
                      <!-- <b-col md="6" class="pb-2">
                      <b-col md="6" class="pb-2">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          name="Google client API"
                        >
                          <b-form-input
                            placeholder="Google Api Key"
                            v-model="googleClientId"
                          ></b-form-input>
                          <span class="validate-error">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </b-col>
                      <!-- <b-col md="6" class="pb-2"> <b>Stage Tracker</b></b-col> -->
                      <!-- <b-col md="6" class="pb-2">
                       <b-form-input placeholder=""></b-form-input> 
                    </b-col> -->
                    </b-row>
                    <div v-if="phn">
                      <h4>Select Market</h4>
                      <b-form inline>
                        <b-form-group
                          class="mb-0 pt-2"
                          v-for="(item, k) in catalogList"
                          :key="k"
                        >
                          <b-form-checkbox
                            type="checkbox"
                            size="lg"
                            :id="item.id"
                            :value="item.id"
                            v-model="market"
                          >
                            <h4 class="m-0 font-weight-light">
                              {{ item.marketName }}
                            </h4>
                          </b-form-checkbox>
                        </b-form-group>
                      </b-form>
                    </div>
                  </b-container>
                  <b-container class="purple-bg mt-4" v-if="phn || web">
                    <h2 class="heading-purple mb-4">Brand Theme Setup</h2>
                    <b-row
                      ><b-col md="6">
                        <color-picker
                          colorRef="primary-col"
                          colorId="primary-col"
                          defaultValue="#2a8750"
                          label="Primary Colour (Brand Colour)"
                          @change="(val) => (primary = val)"
                          ref="primary-colour"
                          class="mb-4"
                        ></color-picker>
                        <color-picker
                          colorRef="header-col"
                          colorId="header-col"
                          defaultValue="#ff6e34"
                          label="Primary Light (Optional)"
                          @change="(val) => (primaryLight = val)"
                          ref="header-primary"
                          class="mb-4"
                        ></color-picker>
                        <color-picker
                          v-if="web"
                          colorRef="footer-BgColor"
                          colorId="footer-BgColor"
                          defaultValue="#a1a1a1"
                          label="Footer Background Color"
                          @change="(val) => (footerBgColor = val)"
                          ref="footer-bg-color"
                          class="mb-4"
                        ></color-picker>
                        <color-picker
                          v-if="web"
                          colorRef="footer-TextColor"
                          colorId="footer-TextColor"
                          defaultValue="#999"
                          label="Text Color"
                          @change="(val) => (footerTextColor = val)"
                          ref="footer-text-color"
                          class="mb-4"
                        ></color-picker>
                        <!-- <color-picker
                                                    v-if="web"
                                                    colorRef="header-BgColor"
                                                    colorId="header-BgColor"
                                                    defaultValue="#fff"
                                                    label="Header Background Color"
                                                    @change="
                                                        (val) =>
                                                            (headerBgColor =
                                                                val)
                                                    "
                                                    ref="header-bg-color"
                                                    class="mb-4"
                                                ></color-picker> -->
                        <!-- <color-picker
                          v-if="web"
                          colorRef="header-TextColor"
                          colorId="header-TextColor"
                          defaultValue="#a1a1a1"
                          label="Header Text Color"
                          @change="(val) => (headerTextColor = val)"
                          ref="header-text-color"
                          class="mb-4"
                        ></color-picker> -->
                        <!-- <color-picker
                          v-if="web"
                          colorRef="border-color"
                          colorId="border-color"
                          defaultValue="#ff8a00"
                          label="Border Color"
                          @change="(val) => (borderColor = val)"
                          ref="ref-border-color"
                          class="mb-4"
                        ></color-picker> -->
                        <color-picker
                          v-if="phn"
                          colorRef="header-col"
                          colorId="header-col"
                          defaultValue="#ffffff"
                          label="Header Font"
                          @change="(val) => (headerFont = val)"
                          ref="font"
                          class="mb-4"
                        ></color-picker>
                        <color-picker
                          v-if="phn"
                          colorRef="header-col"
                          colorId="header-col"
                          :defaultValue="footerNormal"
                          label="Footer Normal Colour"
                          @change="(val) => (footerNormal = val)"
                          ref="footer-normal-colour"
                        ></color-picker>
                        <!-- <b-form-select
                    </b-row>
                    <div v-if="phn">
                      <h4>Select Market</h4>
                      <b-form inline>
                        <b-form-group
                          class="mb-0 pt-2"
                          v-for="(item, k) in catalogList"
                          :key="k"
                        >
                          <b-form-checkbox
                            type="checkbox"
                            size="lg"
                            :id="item.id"
                            :value="item.id"
                            v-model="market"
                          >
                            <h4 class="m-0 font-weight-light">
                              {{ item.marketName }}
                            </h4>
                          </b-form-checkbox>
                        </b-form-group>
                      </b-form>
                    </div>
                  </b-container>
                  <b-container class="purple-bg mt-4" v-if="phn || web">
                    <h2 class="heading-purple mb-4">Brand Theme Setup</h2>
                    <b-row
                      ><b-col md="6">
                        <color-picker
                          colorRef="primary-col"
                          colorId="primary-col"
                          defaultValue="#2a8750"
                          label="Primary Colour (Brand Colour)"
                          @change="(val) => (primary = val)"
                          ref="primary-colour"
                          class="mb-4"
                        ></color-picker>
                        <color-picker
                          colorRef="header-col"
                          colorId="header-col"
                          defaultValue="#ff6e34"
                          label="Primary Light (Optional)"
                          @change="(val) => (primaryLight = val)"
                          ref="header-primary"
                          class="mb-4"
                        ></color-picker>
                        <color-picker
                          v-if="phn"
                          colorRef="header-col"
                          colorId="header-col"
                          defaultValue="#ffffff"
                          label="Header Font"
                          @change="(val) => (headerFont = val)"
                          ref="font"
                          class="mb-4"
                        ></color-picker>
                        <color-picker
                          v-if="phn"
                          colorRef="header-col"
                          colorId="header-col"
                          :defaultValue="footerNormal"
                          label="Footer Normal Colour"
                          @change="(val) => (footerNormal = val)"
                          ref="footer-normal-colour"
                        ></color-picker>
                        <!-- <b-form-select
                        placeholder="Select Font"
                        :options="dataTypes"
                        class="mb-4"
                      ></b-form-select> -->
                      </b-col>
                      <b-col md="6">
                        <color-picker
                          colorRef="primary-dark-col"
                          colorId="primary-dark-col"
                          defaultValue="#284397"
                          label="Primary Dark (Optional)"
                          @change="(val) => (primaryDark = val)"
                          ref="primary-dark-colour"
                          class="mb-4"
                        ></color-picker>

                        <!-- <color-picker
                          v-if="web"
                          colorRef="button-BgColor"
                          colorId="button-BgColor"
                          defaultValue="#ff8a00"
                          label="Button Background Color"
                          @change="(val) => (buttonBgColor = val)"
                          ref="button-bg-color"
                          class="mb-4"
                        ></color-picker> -->
                        <!-- <color-picker
                          v-if="web"
                          colorRef="button-TextColor"
                          colorId="button-TextColor"
                          defaultValue="#fff"
                          label="Button Text Color"
                          @change="(val) => (buttonTextColor = val)"
                          ref="button-text-color"
                          class="mb-4"
                        ></color-picker> -->
                        <!-- <color-picker
                          v-if="web"
                          colorRef="buttonHover-BgColor"
                          colorId="buttonHover-BgColor"
                          defaultValue="#f2f2f2"
                          label="Button Hover Background Color"
                          @change="(val) => (buttonHoverBgColor = val)"
                          ref="buttonHover-bg-color"
                          class="mb-4"
                        ></color-picker> -->
                        <color-picker
                          v-if="web"
                          colorRef="market-BgColor"
                          colorId="market-BgColor"
                          defaultValue="#f7f7f7"
                          label="Market Background Color"
                          @change="(val) => (marketBgColor = val)"
                          ref="market-bg-color"
                          class="mb-4"
                        ></color-picker>
                        <color-picker
                          v-if="phn"
                          colorRef="header-col"
                          colorId="header-col"
                          :defaultValue="headerDefault"
                          label="Footer Selection Colour"
                          @change="(val) => (footerSelection = val)"
                          ref="footer-sel-colour"
                        ></color-picker>
                        <h4>Brand Logo</h4>
                        <single-image
                          height="120px"
                          width="120px"
                          @change="(val) => uploadImage('logo', val)"
                          :id="'appLogo'"
                          :url="images.logo"
                          ref="appLogo"
                          label="Browse for Big Image"
                        ></single-image>
                      </b-col>
                    </b-row>
                    <b-row class="mt-4 preview-area">
                      <b-col md="3" v-if="phn"></b-col>
                      <b-col md="2" v-if="!phn"></b-col>
                      <div
                        v-if="web"
                        :class="{
                          'web-both': phn && web,
                        }"
                      >
                        <laptop-view
                          style="left: 8%"
                          :primary-color="headerTop"
                          :headerTop="headerBottom"
                          :statusBar="headerTop"
                          :app-icon="images.logo"
                          :app-name="appName"
                          :primary-light-color="marketBgColor"
                          :header-font="font"
                        />
                      </div>

                      <div
                        class="mobile"
                        v-if="phn"
                        :class="{
                          'mobile-both': phn && web,
                          'mobile-only': phn && !web,
                        }"
                      >
                        <mobile-view
                          style="left: 13%"
                          :primary-color="primary"
                          :statusBar="headerTop"
                          :headerTop="headerBottom"
                          :header-font="headerFont"
                          :footer-normal="footerNormal"
                          :footer-selection="footerSelection"
                        />
                      </div>
                    </b-row>
                  </b-container>
                  <b-container class="purple-bg mt-4" v-if="phn">
                    <h2 class="heading-purple mb-4">Splash Screen Setup</h2>
                    <b-row
                      ><b-col md="6">
                        <h4>Background Color Splash</h4>
                        <color-picker
                          colorRef="primary-dark-col"
                          colorId="primary-dark-col"
                          defaultValue="#284397"
                          label="Primary Dark (Optional)"
                          @change="(val) => (primaryDark = val)"
                          ref="primary-dark-colour"
                          class="mb-4"
                        ></color-picker>
                        <color-picker
                          v-if="phn"
                          colorRef="header-col"
                          colorId="header-col"
                          :defaultValue="headerDefault"
                          label="Footer Selection Colour"
                          @change="(val) => (footerSelection = val)"
                          ref="footer-sel-colour"
                        ></color-picker>
                        <h4>Brand Logo</h4>
                        <single-image
                          height="120px"
                          width="120px"
                          @change="(val) => uploadImage('logo', val)"
                          :id="'appLogo'"
                          :url="images.logo"
                          ref="appLogo"
                          label="Browse for Big Image"
                        ></single-image>
                      </b-col>
                    </b-row>
                    <b-row class="mt-4 preview-area">
                      <b-col md="3" v-if="phn"></b-col>
                      <b-col md="2" v-if="!phn"></b-col>
                      <div
                        v-if="web"
                        :class="{
                          'web-both': phn && web,
                        }"
                      >
                        <laptop-view
                          :primary-color="headerTop"
                          :headerTop="headerBottom"
                          :statusBar="headerTop"
                          :app-icon="images.logo"
                          :app-name="appName"
                          :primary-light-color="bgColor"
                          :header-font="font"
                        />
                      </div>

                      <div
                        class="mobile"
                        v-if="phn"
                        :class="{
                          'mobile-both': phn && web,
                          'mobile-only': phn && !web,
                        }"
                      >
                        <mobile-view
                          style="left: 13%"
                          :primary-color="primary"
                          :statusBar="headerTop"
                          :headerTop="headerBottom"
                          :header-font="headerFont"
                          :footer-normal="footerNormal"
                          :footer-selection="footerSelection"
                        />
                      </div>
                    </b-row>
                  </b-container>
                  <b-container class="purple-bg mt-4" v-if="phn">
                    <h2 class="heading-purple mb-4">Splash Screen Setup</h2>
                    <b-row
                      ><b-col md="6">
                        <h4>Background Color Splash</h4>

                        <color-picker
                          colorRef="splash-col"
                          colorId="splash-col"
                          defaultValue="#ffffff"
                          label="Splash Background"
                          @change="(val) => (splashBGCol = val)"
                          ref="splash-bg-colour"
                          class="mb-4"
                        ></color-picker>
                        <color-picker
                          colorRef="splash-col"
                          colorId="splash-col"
                          defaultValue="#ffffff"
                          label="Splash Background"
                          @change="(val) => (splashBGCol = val)"
                          ref="splash-bg-colour"
                          class="mb-4"
                        ></color-picker>

                        <!-- <b-form-checkbox
                        <!-- <b-form-checkbox
                        type="checkbox"
                        size="lg"
                        id="splashCheck"
                        value="true"
                      >
                        <h4 class="m-0 font-weight-light">
                          Select default colour (#FFFFFF)
                        </h4>
                      </b-form-checkbox> -->
                        <b-row>
                          <b-col md="6">
                            Splash Screen BG Image
                            <single-image
                              height="200px"
                              width="170px"
                              @change="(val) => uploadImage('splashBGImage', val)"
                              :id="'splashBGImage'"
                              :url="images.splashBGImage"
                              ref="splashBGImage"
                              label="Browse for Big Image"
                            ></single-image
                          ></b-col>
                          <b-col md="6">
                            Splash Logo
                            <single-image
                              height="200px"
                              width="170px"
                              @change="(val) => uploadImage('splashIcon', val)"
                              :id="'splashIcon'"
                              :url="images.splashIcon"
                              ref="splashIcon"
                              label="Browse for Big Image"
                            ></single-image
                          ></b-col>
                        </b-row>
                        <b-button
                          variant="warning"
                          @click="resetSplashScreen()"
                          class="mt-4"
                          style="
                            position: relative;
                            font-size: large;
                            width: 100px;
                            left: 135px;
                          "
                          >Reset</b-button
                        > </b-col
                      ><b-col md="6">
                        <mobile-view
                          class="ml-8"
                          screen="splash"
                          :splash-b-g-image="images.splashBGImage"
                          :splash-b-g-col="splashBGCol"
                          :splash-icon="images.splashIcon"
                        />
                      </b-col>
                    </b-row>
                  </b-container>
                  <b-container class="purple-bg mt-4" v-if="phn">
                    <h2 class="heading-purple mb-4">Notification & App Logo</h2>
                    <b-row
                      ><b-col md="2">
                        App Logo
                        <single-image
                          height="120px"
                          width="120px"
                          @change="(val) => uploadImage('logo', val)"
                          :id="'appLogo'"
                          :url="images.logo"
                          ref="appLogo"
                          label="Browse for Big Image"
                        ></single-image>
                        <div class="m-4"></div>
                        Notification Icon
                        <single-image
                          height="120px"
                          width="120px"
                          @change="(val) => uploadImage('notificationIcon', val)"
                          :id="'notiIcon'"
                          :url="images.notificationIcon"
                          ref="notiIcon"
                          label="Browse for Big Image"
                        ></single-image>
                      </b-col>
                      <b-col md="5">
                        <mobile-view
                          screen="appLogo"
                          class="ml-4"
                          :app-icon="images.logo"
                          :app-name="appName"
                        /> </b-col
                      ><b-col md="5">
                        <mobile-view
                          screen="notification"
                          :notification-icon="images.notificationIcon"
                          :app-name="appName"
                        /> </b-col
                    ></b-row>
                  </b-container>
                  <b-container class="purple-bg mt-4" v-show="false">
                    <h2 class="heading-purple mb-4">Application Theme Setup</h2>
                    <b-row
                      ><b-col md="6">
                        <div>
                          <h5>Header Top Colour</h5>
                          <b-form-checkbox
                            type="checkbox"
                            size="lg"
                            id="headeTop"
                            value="true"
                            @input="primaryUpdate"
                            v-model="headerPrimary"
                          >
                            <h5 class="m-0 font-weight-light">
                              Use Brand Primary Colour
                            </h5>
                          </b-form-checkbox>
                          <color-picker
                            colorRef="headerTop-col"
                            colorId="headerTop-col"
                            :defaultValue="primary"
                            @change="(val) => (headerTop = val)"
                            label="Header Top Colour"
                            ref="headerTop"
                          ></color-picker>
                        </div>
                        <div>
                          <h5>Background Colour</h5>
                          <b-form-checkbox
                            type="checkbox"
                            size="lg"
                            id="primaryLight"
                            value="true"
                            @input="primaryUpdate"
                            v-model="headerPrimaryLight"
                          >
                            <h5 class="m-0 font-weight-light">
                              Use Brand Light Primary Colour
                            </h5>
                          </b-form-checkbox>
                          <color-picker
                            colorRef="primaryLight-col"
                            colorId="primaryLight-col"
                            :defaultValue="primaryLight"
                            @change="(val) => (bgColor = val)"
                            label="Primary Light Colour"
                            ref="bg-color"
                          ></color-picker>
                        </div>
                        <div v-if="phn">
                          <h5>Footer Icon & Text selection Colour</h5>
                          <b-form-checkbox
                            type="checkbox"
                            size="lg"
                            id="footerSelection"
                            value="true"
                            v-model="footerSelectionActive"
                            @input="primaryUpdate"
                          >
                            <h5 class="m-0 font-weight-light">
                              Select Footer Text Colour
                            </h5>
                          </b-form-checkbox>
                          <color-picker
                            colorRef="header-col"
                            colorId="header-col"
                            :defaultValue="headerDefault"
                            label="Footer Selection Colour"
                            @change="(val) => (footerSelection = val)"
                            ref="footer-sel-colour"
                          ></color-picker>
                        </div>
                      </b-col>
                      <b-col md="6">
                        <div>
                          <h5>Select Header Bottom Colour</h5>
                          <b-form-checkbox
                            type="checkbox"
                            size="lg"
                            id="headerBottom"
                            value="true"
                            v-model="headerPrimaryDark"
                            @input="primaryUpdate"
                          >
                            <h5 class="m-0 font-weight-light">
                              Select Primary Dark Colour
                            </h5>
                          </b-form-checkbox>
                          <color-picker
                            colorRef="header-col"
                            colorId="header-col"
                            :defaultValue="primaryDark"
                            label="Header Bottom Colour"
                            @change="(val) => (headerBottom = val)"
                            ref="headerBottom"
                          ></color-picker>
                        </div>
                        <div v-if="phn">
                          <h5>Header Font Colour</h5>
                          <b-form-checkbox
                            type="checkbox"
                            size="lg"
                            id="headerTop"
                            value="true"
                            v-model="headerFontSelection"
                            @input="primaryUpdate"
                          >
                            <h5 class="m-0 font-weight-light">Use Brand Font Colour</h5>
                          </b-form-checkbox>
                          <color-picker
                            colorRef="header-col"
                            colorId="header-col"
                            defaultValue="#ffffff"
                            label="Header Font"
                            @change="(val) => (headerFont = val)"
                            ref="header-font"
                          ></color-picker>
                        </div>
                        <div v-if="phn">
                          <h5>Footer Icon & Text Normal Colour</h5>
                          <b-form-checkbox
                            type="checkbox"
                            size="lg"
                            id="footerNorm"
                            value="true"
                            v-model="footerNormalSelection"
                            @input="primaryUpdate"
                          >
                            <h5 class="m-0 font-weight-light">
                              Select Footer Primary Light Colour
                            </h5>
                          </b-form-checkbox>
                          <color-picker
                            colorRef="header-col"
                            colorId="header-col"
                            :defaultValue="footerNormal"
                            label="Footer Normal Colour"
                            @change="(val) => (footerNormal = val)"
                            ref="footer-normal-colour"
                          ></color-picker>
                        </div>
                        <!-- <b-form-select
                        placeholder="Select Font"
                        :options="dataTypes"
                        class="mb-4"
                      ></b-form-select> -->
                      </b-col>
                    </b-row>
                    <b-row class="mt-4 preview-area">
                      <b-col md="3" v-if="phn"></b-col>
                      <b-col md="2" v-if="!phn"></b-col>
                      <div
                        v-if="web"
                        :class="{
                          'web-both': phn && web,
                        }"
                      >
                        <laptop-view
                          :primary-color="headerTop"
                          :headerTop="headerBottom"
                          :statusBar="headerTop"
                          :app-icon="images.logo"
                          :app-name="appName"
                          :primary-light-color="bgColor"
                          :header-font="font"
                        />
                      </div>

                      <div
                        class="mobile"
                        v-if="phn"
                        :class="{
                          'mobile-both': phn && web,
                          'mobile-only': phn && !web,
                        }"
                      >
                        <mobile-view
                          :primary-color="primary"
                          :statusBar="headerTop"
                          :headerTop="headerBottom"
                          :header-font="headerFont"
                          :footer-normal="footerNormal"
                          :footer-selection="footerSelection"
                        />
                      </div>
                    </b-row>
                  </b-container>
                  <div
                    v-if="web || phn"
                    style="width: 15rem; margin: 15px auto; text-align: center"
                  >
                    <b-button
                      v-if="web && !phn && status != 'Completed'"
                      variant="primary"
                      block
                      @click="updateFieldWeb"
                      style="left: 35px; position: relative"
                      >GENERATE BUILD</b-button
                    >
                    <b-button
                      v-if="web && phn && status != 'Completed'"
                      variant="primary"
                      block
                      @click="updateField"
                      style="left: 35px; position: relative"
                      >GENERATE BUILD</b-button
                    >
                    <b-button
                      v-if="!web && phn && status != 'Completed'"
                      variant="primary"
                      block
                      @click="updateFieldPhn"
                      style="left: 35px; position: relative"
                      >GENERATE BUILD</b-button
                    >
                    <b-button
                      variant="primary"
                      block
                      @click="clearPage"
                      v-if="status === 'Completed'"
                      >Clear</b-button
                    >
                  </div>
                </b-tab>
                <b-tab title="Seller App">
                  <b-container fluid>
                    <b-row>
                      <b-col md="6" class="pb-2">
                        <b-form-input
                          placeholder="Enter App Name"
                          v-model="appName"
                        ></b-form-input
                      ></b-col>
                      <b-col md="6" class="pb-2">
                        <b-form-input
                          placeholder="Enter App Version"
                          v-model="appVersion"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <!-- <b-col md="6" class="pb-2">
                      <b-form-group class="mb-0 pt-2">
                        <b-form-checkbox
                          type="checkbox"
                          size="lg"
                          id="privacy_url"
                          value="true"
                        >
                          <h4 class="m-0 font-weight-bold">
                            Select nipige privacy URL
                          </h4>
                        </b-form-checkbox></b-form-group
                      >
                    </b-col>
                    <b-col md="6" class="pb-2">
                      <b-form-input
                        placeholder="Enter Privacy Policy URL"
                      ></b-form-input>
                    </b-col> -->
                      <b-col md="6" class="pb-2">
                        <b-form-input
                          placeholder="Google Api Key"
                          v-model="googleClientId"
                        ></b-form-input>
                      </b-col>
                      <!-- <b-col md="6" class="pb-2"> <b>Stage Tracker</b></b-col> -->
                      <!-- <b-col md="6" class="pb-2">
                       <b-form-input placeholder=""></b-form-input> 
                    </b-col> -->
                    </b-row>
                    <h4>Select Market</h4>
                    <b-form inline>
                      <b-form-group
                        class="mb-0 pt-2"
                        v-for="(item, k) in catalogList"
                        :key="k"
                      >
                        <b-form-checkbox
                          type="checkbox"
                          size="lg"
                          :id="item.id"
                          :value="item.id"
                          v-model="market"
                        >
                          <h4 class="m-0 font-weight-light">
                            {{ item.marketName }}
                          </h4>
                        </b-form-checkbox>
                      </b-form-group>
                    </b-form>
                  </b-container>
                  <b-container class="purple-bg mt-4">
                    <h2 class="heading-purple mb-4">Brand Theme Setup</h2>
                    <b-row
                      ><b-col md="6">
                        <color-picker
                          colorRef="primary-col"
                          colorId="primary-col"
                          defaultValue="#2a8750"
                          label="Primary Colour (Brand Colour)"
                          @change="(val) => (primary = val)"
                          ref="primary-colour"
                          class="mb-4"
                        ></color-picker>
                        <color-picker
                          colorRef="header-col"
                          colorId="header-col"
                          defaultValue="#ff6e34"
                          label="Primary Light (Optional)"
                          @change="(val) => (primaryLight = val)"
                          ref="header-primary"
                          class="mb-4"
                        ></color-picker>
                        <color-picker
                          colorRef="header-col"
                          colorId="header-col"
                          defaultValue="#ffffff"
                          label="Header Font"
                          @change="(val) => (headerFont = val)"
                          ref="font"
                          class="mb-4"
                        ></color-picker>
                        <color-picker
                          colorRef="header-col"
                          colorId="header-col"
                          :defaultValue="footerNormal"
                          label="Footer Normal Colour"
                          @change="(val) => (footerNormal = val)"
                          ref="footer-normal-colour"
                        ></color-picker>
                        <!-- <b-form-select
                        placeholder="Select Font"
                        :options="dataTypes"
                        class="mb-4"
                      ></b-form-select> -->
                      </b-col>
                      <b-col md="6">
                        <color-picker
                          colorRef="primary-dark-col"
                          colorId="primary-dark-col"
                          defaultValue="#284397"
                          label="Primary Dark (Optional)"
                          @change="(val) => (primaryDark = val)"
                          ref="primary-dark-colour"
                          class="mb-4"
                        ></color-picker>
                        <color-picker
                          colorRef="header-col"
                          colorId="header-col"
                          :defaultValue="headerDefault"
                          label="Footer Selection Colour"
                          @change="(val) => (footerSelection = val)"
                          ref="footer-sel-colour"
                        ></color-picker>
                        <h4>Brand Logo</h4>
                        <single-image
                          height="120px"
                          width="120px"
                          @change="(val) => uploadImage('logo', val)"
                          :id="'appLogo'"
                          :url="images.logo"
                          ref="appLogo"
                          label="Browse for Big Image"
                        ></single-image>
                      </b-col>
                    </b-row>
                    <b-row class="mt-4 preview-area">
                      <b-col md="3"></b-col>
                      <div class="mobile">
                        <mobile-view
                          style="left: 13%"
                          class="ml-8"
                          :primary-color="primary"
                          :statusBar="headerTop"
                          :headerTop="headerBottom"
                          :header-font="headerFont"
                          :footer-normal="footerNormal"
                          :footer-selection="footerSelection"
                        />
                      </div>
                    </b-row>
                  </b-container>
                  <b-container class="purple-bg mt-4">
                    <h2 class="heading-purple mb-4">Splash Screen Setup</h2>
                    <b-row
                      ><b-col md="6">
                        <h4>Background Color Splash</h4>

                        <color-picker
                          colorRef="splash-col"
                          colorId="splash-col"
                          defaultValue="#ffffff"
                          label="Splash Background"
                          @change="(val) => (splashBGCol = val)"
                          ref="splash-bg-colour"
                          class="mb-4"
                        ></color-picker>

                        <!-- <b-form-checkbox
                        <!-- <b-form-checkbox
                        type="checkbox"
                        size="lg"
                        id="splashCheck"
                        value="true"
                      >
                        <h4 class="m-0 font-weight-light">
                          Select default colour (#FFFFFF)
                        </h4>
                      </b-form-checkbox> -->
                        <b-row>
                          <b-col md="6">
                            Splash Screen BG Image (Optional)
                            <single-image
                              height="200px"
                              width="170px"
                              @change="(val) => uploadImage('splashBGImage', val)"
                              :id="'splashBGImage'"
                              :url="images.splashBGImage"
                              ref="splashBGImage"
                              label="Browse for Big Image"
                            ></single-image
                          ></b-col>
                          <b-col md="6">
                            Splash Logo
                            <single-image
                              height="200px"
                              width="170px"
                              style="position: relative; top: 20px"
                              @change="(val) => uploadImage('splashIcon', val)"
                              :id="'splashIcon'"
                              :url="images.splashIcon"
                              ref="splashIcon"
                              label="Browse for Big Image"
                            ></single-image
                          ></b-col>
                        </b-row>
                        <b-button
                          variant="warning"
                          @click="resetSplashScreen()"
                          class="mt-4"
                          style="
                            position: relative;
                            font-size: large;
                            width: 100px;
                            left: 135px;
                          "
                          >Reset</b-button
                        > </b-col
                      ><b-col md="6">
                        <mobile-view
                          class="ml-8"
                          screen="splash"
                          :splash-b-g-image="images.splashBGImage"
                          :splash-b-g-col="splashBGCol"
                          :splash-icon="images.splashIcon"
                        />
                      </b-col>
                    </b-row>
                  </b-container>
                  <b-container class="purple-bg mt-4">
                    <h2 class="heading-purple mb-4">Notification & App Logo</h2>
                    <b-row
                      ><b-col md="2">
                        App Logo
                        <single-image
                          height="120px"
                          width="120px"
                          @change="(val) => uploadImage('logo', val)"
                          :id="'appLogo'"
                          :url="images.logo"
                          ref="appLogo"
                          label="Browse for Big Image"
                        ></single-image>
                        <div class="m-4"></div>
                        Notification Icon
                        <single-image
                          height="120px"
                          width="120px"
                          @change="(val) => uploadImage('notificationIcon', val)"
                          :id="'notiIcon'"
                          :url="images.notificationIcon"
                          ref="notiIcon"
                          label="Browse for Big Image"
                        ></single-image>
                      </b-col>
                      <b-col md="5">
                        <mobile-view
                          screen="appLogo"
                          class="ml-4"
                          :app-icon="images.logo"
                          :app-name="appName"
                        /> </b-col
                      ><b-col md="5">
                        <mobile-view
                          screen="notification"
                          :notification-icon="images.notificationIcon"
                          :app-name="appName"
                        /> </b-col
                    ></b-row>
                  </b-container>
                  <b-container
                    class="purple-bg mt-4"
                    :style="containerHeight()"
                    v-show="false"
                  >
                    <h2 class="heading-purple mb-4">Application Theme Setup</h2>
                    <b-row
                      ><b-col md="6">
                        <div>
                          <h5>Header Top Colour</h5>
                          <b-form-checkbox
                            type="checkbox"
                            size="lg"
                            id="headeTop"
                            value="true"
                            @input="primaryUpdate"
                            v-model="headerPrimary"
                          >
                            <h5 class="m-0 font-weight-light">
                              Use Brand Primary Colour
                            </h5>
                          </b-form-checkbox>
                          <color-picker
                            colorRef="headerTop-col"
                            colorId="headerTop-col"
                            :defaultValue="primary"
                            @change="(val) => (headerTop = val)"
                            label="Header Top Colour"
                            ref="headerTop"
                          ></color-picker>
                        </div>
                        <div>
                          <h5>Background Colour</h5>
                          <b-form-checkbox
                            type="checkbox"
                            size="lg"
                            id="primaryLight"
                            value="true"
                            @input="primaryUpdate"
                            v-model="headerPrimaryLight"
                          >
                            <h5 class="m-0 font-weight-light">
                              Use Brand Light Primary Colour
                            </h5>
                          </b-form-checkbox>
                          <color-picker
                            colorRef="primaryLight-col"
                            colorId="primaryLight-col"
                            :defaultValue="primaryLight"
                            @change="(val) => (bgColor = val)"
                            label="Primary Light Colour"
                            ref="bg-color"
                          ></color-picker>
                        </div>
                        <div>
                          <h5>Footer Icon & Text selection Colour</h5>
                          <b-form-checkbox
                            type="checkbox"
                            size="lg"
                            id="footerSelection"
                            value="true"
                            v-model="footerSelectionActive"
                            @input="primaryUpdate"
                          >
                            <h5 class="m-0 font-weight-light">
                              Select Footer Text Colour
                            </h5>
                          </b-form-checkbox>
                          <color-picker
                            colorRef="header-col"
                            colorId="header-col"
                            :defaultValue="headerDefault"
                            label="Footer Selection Colour"
                            @change="(val) => (footerSelection = val)"
                            ref="footer-sel-colour"
                          ></color-picker>
                        </div>
                      </b-col>
                      <b-col md="6">
                        <div>
                          <h5>Select Header Bottom Colour</h5>
                          <b-form-checkbox
                            type="checkbox"
                            size="lg"
                            id="headerBottom"
                            value="true"
                            v-model="headerPrimaryDark"
                            @input="primaryUpdate"
                          >
                            <h5 class="m-0 font-weight-light">
                              Use Brand Primary Dark Colour
                            </h5>
                          </b-form-checkbox>
                          <color-picker
                            colorRef="header-col"
                            colorId="header-col"
                            :defaultValue="primaryDark"
                            label="Header Bottom Colour"
                            @change="(val) => (headerBottom = val)"
                            ref="headerBottom"
                          ></color-picker>
                        </div>
                        <div>
                          <h5>Header Font Colour</h5>
                          <b-form-checkbox
                            type="checkbox"
                            size="lg"
                            id="headerTop"
                            value="true"
                            v-model="headerFontSelection"
                            @input="primaryUpdate"
                          >
                            <h5 class="m-0 font-weight-light">Use Brand Font Colour</h5>
                          </b-form-checkbox>
                          <color-picker
                            colorRef="header-col"
                            colorId="header-col"
                            defaultValue="#ffffff"
                            label="Header Font"
                            @change="(val) => (headerFont = val)"
                            ref="header-font"
                          ></color-picker>
                        </div>
                        <div>
                          <h5>Footer Icon & Text Normal Colour</h5>
                          <b-form-checkbox
                            type="checkbox"
                            size="lg"
                            id="footerNorm"
                            value="true"
                            v-model="footerNormalSelection"
                            @input="primaryUpdate"
                          >
                            <h5 class="m-0 font-weight-light">
                              Select Footer Primary Light Colour
                            </h5>
                          </b-form-checkbox>
                          <color-picker
                            colorRef="header-col"
                            colorId="header-col"
                            :defaultValue="footerNormal"
                            label="Footer Normal Colour"
                            @change="(val) => (footerNormal = val)"
                            ref="footer-normal-colour"
                          ></color-picker>
                        </div>
                        <!-- <b-form-select
                        placeholder="Select Font"
                        :options="dataTypes"
                        class="mb-4"
                      ></b-form-select> -->
                      </b-col>
                    </b-row>
                    <b-row class="mt-4 preview-area">
                      <b-col md="3"></b-col>
                      <div class="mobile">
                        <mobile-view
                          class="ml-8"
                          :primary-color="primary"
                          :statusBar="headerTop"
                          :headerTop="headerBottom"
                          :header-font="headerFont"
                          :footer-normal="footerNormal"
                          :footer-selection="footerSelection"
                        />
                      </div>
                    </b-row>
                  </b-container>
                  <div style="width: 15rem; margin: 15px auto; text-align: center">
                    <b-button
                      v-if="status != 'Completed'"
                      variant="primary"
                      block
                      @click="updateFieldPhn"
                      :disabled="status == 'Completed'"
                      style="left: 35px; position: relative"
                      >GENERATE SELLER BUILD
                    </b-button>
                    <b-button
                      v-if="status === 'Completed'"
                      variant="primary"
                      block
                      @click="clearPage"
                      >Clear</b-button
                    >
                  </div>
                </b-tab>
                <!-- <b-tab title="Fulfillment App">
                <b-container fluid> </b-container
              ></b-tab> -->
                <b-tab title="Build History">
                  <b-container fluid>
                    <b-row>
                      <b-col>
                        <b-button
                          size="sm"
                          variant="success"
                          style="width: 42px; height: 35px; float: right"
                          @click="fetchStatus()"
                          :disabled="loading"
                        >
                          <span
                            v-if="loading"
                            class="fa fa-refresh fa-spin"
                            style="font-size: 15px"
                          />
                          <span v-else class="fa fa-refresh" style="font-size: 15px" />
                        </b-button>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <b-table
                          style="border-radius: 12px"
                          :dark="dark"
                          :hover="hover"
                          :striped="striped"
                          :bordered="bordered"
                          :small="small"
                          :fixed="fixed"
                          responsive
                          class="tableRadius"
                          :items="filteredData"
                          :fields="columns"
                          :filter="filter"
                          thead-class="header"
                          show-empty
                        >
                          <template slot="url" slot-scope="data">
                            <a :href="data.item.url" target="_blank">{{
                              data.item.url
                            }}</a>
                          </template>
                        </b-table>
                      </b-col>
                    </b-row>
                  </b-container></b-tab
                >
              </b-tabs>
            </b-col>
          </b-row>
        </b-card>
      </ValidationObserver>
    </b-col>
  </b-row>
</template>
<script>
import profile from "@/components/profile/profileCategory";
import currentUserData from "@/mixins/currentUser";
import VueUploadMultipleImage from "@/components/FormElements/VueUploadMultipleImage.vue";
import SingleImage from "../../components/Common/Image.vue";
import { mapState, mapGetters } from "vuex";
import mobileView from "./mobileView.vue";
import {
  ValidationProvider,
  ValidationObserver,
} from "vee-validate/dist/vee-validate.esm";
import moment from "moment";
import laptopView from "./laptopView.vue";
import cInput from "@/components/FormElements/CustomInput";
import ColorPicker from "@/components/FormElements/ColorPicker.vue";
import ComponentHeader from "@/components/componentNewHeader";
import Vue from "vue";
export default {
  components: {
    profile,
    cInput,
    ColorPicker,
    VueUploadMultipleImage,
    SingleImage,
    mobileView,
    laptopView,
    ComponentHeader,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [currentUserData],
  data() {
    return {
      user: {},
      phn: false,
      web: false,
      tabIndex: 0,
      googleClientId: "",
      appName: "",
      appVersion: "",
      headerDefault: "#ff6e34",
      primary: "#2a8750",
      primaryLight: "#ff6e34",
      primaryDark: "#284397",
      footerBgColor: "#a1a1a1",
      footerTextColor: "#808080",
      // headerBgColor: "#fff",
      headerTextColor: "#a1a1a1",
      borderColor: "#ff8a00",
      buttonBgColor: "#ff8a00",
      buttonTextColor: "#fff",
      buttonHoverBgColor: "#f2f2f2",
      marketBgColor: "#f7f7f7",
      font: "#fff",
      headerTop: "#2a8750",
      headerBottom: "#284397",
      bgColor: "#ff6e34",
      headerFont: "#fff",
      footerNormal: "#2a8750",
      footerSelection: "#000000",
      status: "PENDING",
      headerPrimary: true,
      headerPrimaryDark: true,
      headerPrimaryLight: true,
      headerFontSelection: true,
      footerNormalSelection: true,
      footerSelectionActive: true,
      splashBGCol: "#ffffff",
      catalogList: [],
      market: [],
      intervalId: "",
      images: {
        splashIcon: null,
        splashBGImage: null,
        notificationIcon: null,
        logo: null,
      },
      filter: "",
      loading: false,
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      fixed: false,
      dark: false,
      columns: [
        // {
        //   key: "request",
        //   label: "#Request",
        // },
        {
          key: "requested_date",
          label: "Requested Date",
        },
        {
          key: "app_type",
          label: "App Type",
        },
        {
          key: "build_version",
          label: "Build Version",
        },
        {
          key: "url",
          label: "URL",
        },
        {
          key: "status",
          label: "Status",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      extendedList: (state) => state.tenant.extendedList,
      marketList: (state) => state.profile.marketList,
    }),
    ...mapGetters({
      historyList: "profile/GetHistory",
    }),
    filteredData() {
      const buildHistory = [
        {
          requested_date: this.formatDateTime(this.historyList?.web?.customer?.startedAt),
          app_type: "Web Customer",
          build_version: "-",
          url: this.historyList?.web?.customer?.buildFileUrl || "-",
          status: this.historyList?.web?.customer?.status || "-",
        },
        {
          requested_date: this.formatDateTime(
            this.historyList?.android?.customer?.startedAt
          ),
          app_type: "Android Customer",
          build_version: this.historyList?.android?.customer?.version || "-",
          url: this.historyList?.android?.customer?.buildFileUrl || "-",
          status: this.historyList?.android?.customer?.status || "-",
        },
        {
          requested_date: this.formatDateTime(
            this.historyList?.android?.seller?.startedAt
          ),
          app_type: "Android Seller",
          build_version: this.historyList?.android?.seller?.version || "-",
          url: this.historyList?.android?.seller?.buildFileUrl || "-",
          status: this.historyList?.android?.seller?.status || "-",
        },
      ];
      return buildHistory.filter((item) =>
        ["completed", "initiated"].includes(item.status.toLowerCase())
      );
    },
  },
  methods: {
    containerHeight() {
      if (this.phn && this.web) return "height:105rem;";
      if (this.phn && !this.web) return "height:80rem;";
      if (this.web && !this.phn) return "height:56rem;";
    },
    primaryColorChange(val) {
      this.primary = val;
      this.primaryUpdate();
    },
    changeSplashBGImage(val) {
      this.splashBGImage = val || null;
    },
    changeSplashIcon(val) {
      this.splashIcon = val || null;
    },
    resetSplashScreen() {
      this.images.splashBGImage = "";
      this.images.splashIcon = "";
      if (this.$refs.splashBGImage) {
        this.$refs.splashBGImage.reset();
      }
      if (this.$refs.splashIcon) {
        this.$refs.splashIcon.reset();
      }
      this.splashBGCol = "#ffffff";
      this.$refs["splash-bg-colour"]?.updateColor(this.splashBGCol);
    },
    primaryUpdate() {
      if (this.headerPrimary) {
        this.headerTop = this.primary;
        this.$refs["headerTop"]?.updateColor(this.primary);
      }
      if (this.headerPrimaryDark) {
        this.headerBottom = this.primaryDark;
        this.$refs["headerBottom"]?.updateColor(this.primaryDark);
      }
      if (this.headerPrimaryLight) {
        this.bgColor = this.primaryLight;
        this.$refs["bg-color"]?.updateColor(this.primaryLight);
      }
      if (this.headerFontSelection) {
        this.headerFont = this.font;
        this.$refs["headerFont"]?.updateColor(this.font);
      }
      if (this.footerNormalSelection) {
        this.footerNormal = this.primary;
        this.$refs["footer-normal-colour"]?.updateColor(this.primary);
      }
      if (this.footerSelectionActive) {
        this.footerSelection = this.primaryLight;
        this.$refs["footer-sel-colour"]?.updateColor(this.primaryLight);
      }
    },
    showCustomToast() {
      Vue.toasted.show("Uploading...", {
        type: "info",
        theme: "toasted-primary",
        singleton: true,
        duration: 1000000,
      });
    },
    clearCustomToast() {
      Vue.toasted.clear();
    },
    async uploadImage(path, image) {
      let dataobj = {
        image: image,
        key: (
          Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
        ).toLowerCase(),
        isPublic: true,
        replaceExisting: true,
        basePath: "tenant",
      };
      this.showCustomToast();
      await this.$store
        .dispatch("inventory/uploadImageToStorage", dataobj)
        .then((res) => {
          this.clearCustomToast();
          this.images[path] = res.data.fileUrl;
        })
        .catch((error) => {
          this.clearCustomToast();
          this.$toasted.error("Image not uploaded..please try again!");
        });
    },
    formatDateTime: function (value) {
      if (!value) {
        return "-";
      }
      return moment(value).format("DD/MM/YYYY  h:mm A");
    },
    async updateFieldWeb() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        this.$swal({
          title: "Please fill all the fields",
          type: "warning",
        });
        return;
      }
      if (!this.primary.length || !this.primaryLight.length || !this.primaryDark.length) {
        this.$toasted.error("Please select all colors!");
        return;
      }
      if (!this.images.logo) {
        this.$toasted.error("Please upload logo!");
        return;
      }
      if (!this.googleClientId.length) {
        this.$toasted.error("Please enter google client id");
        return;
      }
      const payload = {
        tenant: this.$currentUserData._id,
        type: "web",
        data: {
          type: "web",
          theme: {
            primary: this.primary,
            primaryLight: this.primaryLight,
            primaryDark: this.primaryDark,
            secondary: this.footerBgColor,
            secondaryDark: this.footerTextColor,
            secondaryLight: this.marketBgColor,
            logo: this.images.logo,
            icon: this.images.logo,
          },
          service: {
            url: "",
            tenant: this.$currentUserData._id,
            googleClientId: this.googleClientId,
            cashFreeMode: "production",
          },
        },
      };
      try {
        await this.$store.dispatch("profile/buildConfig", payload);
        if (this.web) {
          this.buildConfig();
        }
      } catch (error) {
        console.error(error);
      }
    },
    async updateFieldPhn() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        this.$swal({
          title: "Please fill all the fields",
          type: "warning",
        });
        return;
      }
      if (!this.images.logo) {
        this.$toasted.error("Please upload logo!");
        return;
      }
      const payload = {
        tenant: this.$currentUserData._id,
        type: "mobile",
        data: {
          type: "mobile",
          platform: "mobile",
          appName: this.appName,
          version: this.appVersion,
          baseUrl: "",
          bucketBaseurl: "https://nipigedev-storage.s3.amazonaws.com",
          gApiKey: this.googleClientId,
          currency: "₹",
          cashFreeEnv: "production",
          tenant: this.$currentUserData._id,
          legal: "https://eparisheva.com/#/privacy-policy",
          travelMarketId: "travel",
          rechargeMarketId: "recharge",
          markets: [],
          theme: {
            splashScreen: {
              bgColor: this.splashBGCol,
              bgImage: this.images.splashBGImage,
              bgIcon: this.images.splashIcon,
            },
            logo: {
              app: this.images.logo,
              notification: this.images.notificationIcon,
            },
            colorSchema: {
              basicColor: this.primaryLight,
              statusBarBgColor: this.primary,
              defaultAppIconColor: this.primaryDark,
              selectedAppIconColor: this.primary,
              defaultAppIconTextColor: this.footerNormal,
              selectedAppIconTextColor: this.footerSelection,
              primary: this.primary,
              headerGradient: [this.primary, this.primaryDark],
            },
          },
          font: {
            fontSize: 12,
            fontColor: "Black",
            fontWeight: 400,
            fontFamily: "Montserrat-Regular",
          },
        },
      };
      if (this.market) {
        this.market.map((x) => {
          this.catalogList.map((y) => {
            if (x === y.id) {
              const data = { marketName: y.marketName, id: y.id };
              payload.data.markets.push(data);
            }
          });
        });
      }
      try {
        await this.$store.dispatch("profile/buildConfig", payload);
        this.buildConfig();
      } catch (error) {
        console.error(error);
      }
    },
    async updateField() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        this.$swal({
          title: "Please fill all the fields",
          type: "warning",
        });
        return;
      }
      if (!this.primary.length || !this.primaryLight.length || !this.primaryDark.length) {
        this.$toasted.error("Please select all colors!");
        return;
      }
      if (!this.images.logo) {
        this.$toasted.error("Please upload logo!");
        return;
      }
      if (!this.googleClientId.length) {
        this.$toasted.error("Please enter google client id");
        return;
      }
      const payload = {
        tenant: this.$currentUserData._id,
        type: "web",
        data: {
          type: "web",
          theme: {
            primary: this.primary,
            primaryLight: this.primaryLight,
            primaryDark: this.primaryDark,
            secondary: this.footerBgColor,
            secondaryDark: this.footerTextColor,
            secondaryLight: this.marketBgColor,
            logo: this.images.logo,
            icon: this.images.logo,
          },
          service: {
            url: "",
            tenant: this.$currentUserData._id,
            googleClientId: this.googleClientId,
            cashFreeMode: "production",
          },
        },
      };
      try {
        await this.$store.dispatch("profile/buildConfig", payload);
        if (this.web) {
          this.buildConfig();
        }
      } catch (error) {
        console.error(error);
      }
      if (!this.images.logo) {
        this.$toasted.error("Please upload logo!");
        return;
      }
      const payload1 = {
        tenant: this.$currentUserData._id,
        type: "mobile",
        data: {
          type: "mobile",
          platform: "mobile",
          appName: this.appName,
          version: this.appVersion,
          baseUrl: "",
          bucketBaseurl: "https://nipigedev-storage.s3.amazonaws.com",
          gApiKey: this.googleClientId,
          currency: "₹",
          cashFreeEnv: "production",
          tenant: this.$currentUserData._id,
          legal: "https://eparisheva.com/#/privacy-policy",
          travelMarketId: "travel",
          rechargeMarketId: "recharge",
          markets: [],
          theme: {
            splashScreen: {
              bgColor: this.splashBGCol,
              bgImage: this.images.splashBGImage,
              bgIcon: this.images.splashIcon,
            },
            logo: {
              app: this.images.logo,
              notification: this.images.notificationIcon,
            },
            colorSchema: {
              basicColor: this.primaryLight,
              statusBarBgColor: this.primary,
              defaultAppIconColor: this.primaryDark,
              selectedAppIconColor: this.primary,
              defaultAppIconTextColor: this.footerNormal,
              selectedAppIconTextColor: this.footerSelection,
              primary: this.primary,
              headerGradient: [this.primary, this.primaryDark],
            },
          },
          font: {
            fontSize: 12,
            fontColor: "Black",
            fontWeight: 400,
            fontFamily: "Montserrat-Regular",
          },
        },
      };
      if (this.market) {
        this.market.map((x) => {
          this.catalogList.map((y) => {
            if (x === y.id) {
              const data = { marketName: y.marketName, id: y.id };
              payload1.data.markets.push(data);
            }
          });
        });
      }
      try {
        await this.$store.dispatch("profile/buildConfig", payload1);
        this.buildConfig();
      } catch (error) {
        console.error(error);
      }
    },
    async buildConfig() {
      if (this.phn && this.web) {
        try {
          const data = {
            buildTypes: [0, 3],
            tenant: this.$currentUserData._id,
          };
          await this.$store.dispatch("profile/buildGenerate", data).then((respData) => {
            this.$swal({
              text: "Build Execution in process...",
              type: "success",
            });
            this.fetchStatus();
          });
        } catch (error) {
          this.$toasted.error(data.message);
        }
      } else if (this.phn && !this.web) {
        try {
          const data = {
            buildTypes: [0],
            tenant: this.$currentUserData._id,
          };
          await this.$store.dispatch("profile/buildGenerate", data).then((respData) => {
            this.$swal({
              text: "Build Execution in process...",
              type: "success",
            });
          });
          this.fetchStatus();
        } catch (e) {
          this.$toasted.error(data.message);
        }
      } else if (this.web && !this.phn) {
        try {
          const data = {
            buildTypes: [3],
            tenant: this.$currentUserData._id,
          };
          await this.$store.dispatch("profile/buildGenerate", data).then((respData) => {
            this.$swal({
              text: "Build Execution in process...",
              type: "success",
            });
            this.intervalId = setInterval(() => {
              this.fetchStatus();
            }, 20000);
          });
        } catch (e) {
          this.$toasted.error(data.message);
        }
      } else {
        const data = {
          buildTypes: [1],
          tenant: this.$currentUserData._id,
        };
        await this.$store.dispatch("profile/buildGenerate", data).then((respData) => {
          this.$swal({
            text: "Build Execution in process...",
            type: "success",
          });
          this.fetchStatus();
        });
      }
    },
    clearPage() {
      location.reload();
    },
    async fetchStatus() {
      this.loading = true;
      try {
        const payload = {
          id: this.$currentUserData._id,
        };
        const resp = await this.$store.dispatch("profile/buildStatusAction", payload);
        if (resp?.data?.response?.web?.customer?.status === "Completed" && this.web) {
          const url = resp.data.response.web?.customer?.buildFileUrl;
          this.$swal({
            type: "success",
            title: "Visit your website",
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: `Open`,
            cancelButtonText: `Later`,
          }).then((result) => {
            if (result.value) {
              window.open(url, "_blank");
            } else if (result.isDenied) {
              swal.close();
            }
          });
          clearInterval(this.intervalId);
        }
        if (
          resp?.data?.response?.android?.customer?.status === "Completed" &&
          this.phn &&
          this.web
        ) {
          const webUrl = resp.data.response.web?.customer?.buildFileUrl;
          this.$swal({
            type: "success",
            title: "Visit your website",
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: `Open`,
            cancelButtonText: `Later`,
          }).then((result) => {
            if (result.value) {
              window.open(webUrl, "_blank");
            } else if (result.isDenied) {
              swal.close();
            }
          });
          clearInterval(this.intervalId);
        }
        if (resp?.data?.response?.web?.customer?.status != "Completed" && this.web) {
          this.status = resp.data.response.web?.customer?.status;
          this.$swal({
            title: "",
            text: `Web Customer - ${resp.data.response.web?.customer?.status}`,
            type: "success",
            timer: 5000,
            showCancelButton: false,
            showConfirmButton: false,
          });
        }
        if (resp?.data?.response?.android?.customer?.status != "Completed" && this.phn) {
          this.status = resp.data.response.android.customer?.status;
          this.$swal({
            title: "",
            text: `Mobile Customer - ${resp.data.response.android.customer?.status}`,
            type: "success",
            timer: 5000,
            showCancelButton: false,
            showConfirmButton: false,
          });
        }
        if (
          resp.data.response.android.customer?.status != "Completed" &&
          this.phn &&
          this.web
        ) {
          this.status = resp.data.response.web.customer?.status;
          this.$swal({
            title: "",
            text: `Mobile and Web Customer  - ${resp.data.response.web?.customer?.status} and ${resp.data.response.android.customer?.status}`,
            type: "success",
            timer: 5000,
            showCancelButton: false,
            showConfirmButton: false,
          });
        }
        if (
          resp.data.response.android.seller?.status != "Completed" &&
          this.tabIndex === 1
        ) {
          this.status = resp.data.response.android.seller?.status;
          this.$swal({
            title: "",
            text: `Mobile Seller - ${resp.data.response.android.seller?.status}`,
            type: "success",
            timer: 5000,
            showCancelButton: false,
            showConfirmButton: false,
          });
        }
      } catch (err) {}
      this.loading = false;
      this.loading = false;
    },
    async fetchCatalog() {
      let searchString = "isRoot=y";
      await this.$store.dispatch("catalog/fetchCatalogList", searchString).then((x) => {
        searchString = `isDomain=y&parent=${x.data.response[0]._id}`;
        this.$store.dispatch("catalog/fetchCatalogList", searchString).then((y) => {
          searchString = `parent=${y.data.response[0]._id}`;
          this.$store.dispatch("catalog/fetchCatalogList", searchString).then((z) => {
            const list = [];
            z.data.response.map((obj) => {
              const arrayobj = {
                marketName: obj.name,
                id: obj._id,
              };
              list.push(arrayobj);
            });
            this.catalogList = list;
          });
        });
      });
    },
  },
  mounted() {
    this.loading = true;
    this.fetchCatalog();
    this.loading = false;
    this.user = this.$store.getters["auth/getloginUser"];
    this.$store.dispatch("profile/buildStatusAction", {
      id: this.$currentUserData._id,
    });
  },
  created() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
};
</script>
<style>
.language-button button {
  width: 160px;
  margin-bottom: 15px;
  margin-left: 15px;
  margin-right: 15px;
  font-size: 14px;
}
.card-img-top {
  height: 70px;
  width: auto;
  max-width: 100%;
}
.card-body {
  padding: 15px;
}
.card-footer {
  border-top: 2px dashed #c8d1d7;
}
@media (max-width: 768px) {
  .language-button button {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
}
.center {
  text-align: center;
}
.headclass .thead-light th {
  color: var(--secondary);
  background-color: #f1f3fa;
  border-color: #e3eaef;
  padding: 1rem;
}
.headclass .thead-light {
  border-radius: 10px;
}
.headclass td {
  border-top: 1px solid #f1f5f8;
}
.description {
  color: black;
}
.round {
  border-radius: 50%;
  height: 30px;
  width: 30px;
  padding: 0;
}
.nav-tabs .nav-link.active {
  color: #4140e2;
}
.header-text .modal-title {
  font-size: 1.2rem;
  color: #4140e2;
  text-align: left;
}
.modal-content {
  padding: 1rem;
}
select.form-control:not([size]):not([multiple]) {
  height: calc(3.2125rem - 6px);
}
.custom-file-label::after {
  background-color: #727cf5 !important;
  color: #fff !important;
  line-height: 1.2 !important;
}

.theme {
  height: 47px;
  margin-top: -3px;
  width: 53px;
}

.color-input {
  width: 350px !important;
  margin-left: 7px !important;
  height: 40px !important;
  margin-top: 1px !important;
}

.icon {
  height: 38px !important;
  margin-left: 5rem !important;
  margin-top: 1px;
}

.slug-name {
  width: 380px !important;
}

.slug {
  margin-left: 52px !important;
}
.purple-bg {
  background: #e9e7ff3b;
  border: 1px solid #dee3ea;
  min-height: 1rem !important;
}
.heading-purple {
  color: #3b3ad9;
  font-size: 15px;
  text-transform: uppercase;
}
h5 {
  margin-bottom: 1rem;
}
.preview-area {
  position: relative;
  margin-bottom: 60px;
}
.mobile {
  z-index: 2;
  top: 120px;
}
.mobile-both {
  position: relative;
  top: 55px;
  left: 253px;
}
.mobile-only {
  margin-left: 63px;
}
.web-both {
  position: relative;
  right: 62px;
}
</style>
